import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-rfi-request',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './rfi-request.component.html',
  styleUrl: './rfi-request.component.css'
})
export class RfiRequestComponent {

}
